const columns = (companyFilters = []) => ([
  {
    title: 'Company',
    dataIndex: 'companyId',
    key: 'companyId',
    filters: companyFilters,
    onFilter: (value, record) => String(record.companyId || '') === String(value),
  },
  {
    title: 'Percentage',
    dataIndex: 'percent',
    key: 'percent',
  },
  {
    title: 'Default can rush',
    dataIndex: 'isDefault',
    key: 'isDefault',
  },
  {
    title: 'Digitize text',
    dataIndex: 'digitize',
    key: 'digitize',
  },
  {
    title: 'Enhance text',
    dataIndex: 'enhance',
    key: 'enhance',
  },
  {
    title: 'Photo art text',
    dataIndex: 'photoArt',
    key: 'photoArt',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
